import React from "react";
import FormInput from "../widgets/FormInput";
import { showSuccessToast } from "src/lib/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createTag } from "src/api/settings";
import { Button } from "../ui/button";
import * as Yup from "yup";
import { Formik } from "formik";
import { usePortalContext } from "src/context/PortalContext";

const validationSchema = Yup.object().shape({
	name: Yup.string().required("Tag name is required"),
});

const NewTagModal = () => {
	const closePortal = usePortalContext();
	const queryClient = useQueryClient();

	const initialValues = {
		name: "",
	};

	const { mutate, isLoading } = useMutation(createTag, {
		onSuccess: () => {
			showSuccessToast("Tag created successfully");
			queryClient.invalidateQueries(["tags"]);
			closePortal();
		},
	});

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit }) => (
				<form onSubmit={handleSubmit}>
					<FormInput
						label="Tag Name"
						name="name"
						type="text"
						placeholder="Tag Name"
						value={values.name}
						onChange={handleChange}
						className="fullFormItem"
					/>

					<Button variant="secondary" className="tw-w-full" disabled={isLoading}>
						{isLoading ? "Adding..." : "Add Tag"}
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default NewTagModal;
